module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobile),
      expression: "!isMobile"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "guide left"
  }, [_c('p', [_c('a', _vm._b({
    attrs: {
      "href": "https://github.com",
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, 'a', {
    title: _vm.linkTitle
  }, false), [_vm._v(_vm._s(_vm.github) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "transform": "scale(1.68)",
      "transform-origin": "center left"
    },
    attrs: {
      "src": "https://ghbtns.com/github-btn.html?user=Binaryify&repo=vue-tetris&type=star&count=true",
      "frameBorder": "0",
      "scrolling": "0",
      "width": "170px",
      "height": "20px"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "transform": "scale(1.68)",
      "transform-origin": "center left"
    },
    attrs: {
      "src": "https://ghbtns.com/github-btn.html?user=Binaryify&repo=vue-tetris&type=fork&count=true",
      "frameBorder": "0",
      "scrolling": "0",
      "width": "170px",
      "height": "20px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_vm._v("SPACE")])]), _vm._v(" "), _c('div', {
    staticClass: "guide qr"
  }, [_c('img', _vm._b({
    attrs: {
      "src": _vm.QRSrc
    }
  }, 'img', {
    title: _vm.QRTitle,
    alt: _vm.QRCode
  }, false))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide right"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(0,-3px) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(-7px,3px) rotate(-90deg) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(0,9px) rotate(180deg) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(7px,3px)rotate(90deg) scale(1,2)"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-65526da2","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/guide/index.vue
// module id = 140
// module chunks = 1